/**
 * Query keys for svc-studio (BriefCase) API hooks.
 *
 * Centralised keys enable consistent cache invalidation across all studio hooks.
 */

export const studioQueryKeys = {
  all: ['studio'] as const,
  jobs: () => [...studioQueryKeys.all, 'job'] as const,
  job: (jobId: string | null) => [...studioQueryKeys.jobs(), jobId] as const,
  offerSearch: (
    query: string,
    propertyScope: string | null,
    excludeOfferId: string | null,
    currencyScope: string | null,
    productLine: string | null = null,
    targetType: string | null = null,
  ) =>
    [
      ...studioQueryKeys.all,
      'offer-search',
      query,
      propertyScope ?? '',
      excludeOfferId ?? '',
      currencyScope ?? '',
      productLine ?? 'hotel',
      targetType ?? 'offer',
    ] as const,
  template: (deckType: string) => [...studioQueryKeys.all, 'template', deckType] as const,
  templateVersions: (deckType: string) => [...studioQueryKeys.template(deckType), 'versions'] as const,
};
